import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import LabelFont from '../../Theme/Fonts/Label'
import { getFontColorByBackgroundColor } from '../../utils/Colors'
import { TestID } from '../../utils/PropTypesDefinitions'

export type BadgeProps = {
    /** Number shown inside the badge */
    children: number
    /** The type refers to the backgroundColor of the badge */
    backgroundColor: 'onyx' | 'keshi-3' | 'ORANGE' | 'pearl'
} & TestID

const Badge: FunctionComponent<BadgeProps> = ({
    children,
    backgroundColor,
    testID,
}): ReactElement | null =>
    children ? (
        <Grid horizontal noExpand testID={testID}>
            <Grid
                noExpand
                backgroundColor={backgroundColor}
                borderRadius={4}
                width={`${children}`.length === 1 ? 16 : undefined}
                paddingX={`${children}`.length === 1 ? 0 : 2}
            >
                <LabelFont
                    color={getFontColorByBackgroundColor(backgroundColor)}
                    uppercase
                    bold
                    textAlign="center"
                    allowFontScaling={false}
                >
                    {`${children}`}
                </LabelFont>
            </Grid>
        </Grid>
    ) : null

export default memo(Badge)
